import { notifications } from '@mantine/notifications';
import { sellerOnboardingApi } from './api';

/** Файлы хранилища (паспорт, ЕГРЮЛ, оферта) — открываем по временной ссылке; остальное — как обычную ссылку. */
export function isStorageDocumentUrl(url: string | null | undefined): boolean {
  const s = (url ?? '').trim();
  return s.startsWith('https://s3.regru.cloud/') || s.startsWith('https://mock-s3.local/');
}

/**
 * Паспорт, ЕГРЮЛ и оферта лежат в закрытом бакете — ссылку выдаёт бэкенд на несколько минут.
 * Вкладку открываем синхронно по клику: после await браузер заблокировал бы всплывающее окно.
 */
export function openSellerDocument(url: string): void {
  const win = window.open('', '_blank');
  if (win) win.opener = null;
  sellerOnboardingApi
    .documentLink(url)
    .then((signed) => {
      if (win) win.location.href = signed;
      else window.location.assign(signed);
    })
    .catch(() => {
      win?.close();
      notifications.show({ title: 'Ошибка', message: 'Не удалось открыть документ', color: 'red' });
    });
}
